/* eslint-disable lingui/no-unlocalized-strings */
import { DateTime, Interval } from "luxon";

import { Strategy } from "../reports.flow";

class TrialStrategy implements Strategy {
  public isMasked(interval: Interval, date: DateTime) {
    return interval.contains(date);
  }

  public getDummyReport(): ReturnType<Strategy["getDummyReport"]> {
    return {
      commodities: Array.from({ length: 4 }).map((_, i) => ({
        commodity: {
          icon: null as unknown as string,
          id: i,
          name: "Lorem",
        },
        headline: "Lorem ipsum odor amet, consectetuer adipiscing elit.",
        recommendation: "BULLISH",
        recommendationText:
          "Lorem ipsum odor amet, consectetuer adipiscing elit.",
        summary:
          "Lorem ipsum odor amet, consectetuer adipiscing elit. Pellentesque magna venenatis; vitae sem eget imperdiet.",
      })),
    };
  }
}

export { TrialStrategy };
